import MaillerForm from "./MaillerForm";
import {useEffect, useMemo, useState} from "react";
import {Col, Row} from "antd";
import MaillerHistory from "./MaillerHistory";
import Constants from "../../utils/constants";

export default function MaillerContainer({action, owner, bdd, document}) {
	// Pour le futur dev des documents
	//const [open, setOpen] = useState(false);
	//const handleClose = () => setOpen(false);

	const [newPiecesJointe, setNewPiecesJointe] = useState(null);
	const { requete, location } = bdd;

	useEffect(() => {
		setNewPiecesJointe(null);
	}, [requete]);

	useEffect(() => {

		//console.log('useEffect document', document);
		if (document) {
			setNewPiecesJointe({
				uid: document.document_id,
				name: document.document_nom,
				status: "done",
				ref: `${document.document_dossier.dossier_url}${document.document_tag.tag_libelle}/`,
				url: `${Constants.directory}documents/${document.document_dossier.dossier_url}${document.document_tag.tag_libelle}/${document.document_nom}`,
			});
		}

	}, [document]);

	const getLangue = () => {

		const code = 'FR';

		if (requete) {
			if (
				requete.requete_locataire &&
				requete.requete_locataire.locataire_personne.personne_langue
			) {
				return requete.requete_locataire.locataire_personne.personne_langue.langue_code;
			}
		} else {
			if (owner?.proprietaire_personne?.personne_langue) {
				return owner.proprietaire_personne.personne_langue.langue_code;
			}
		}

		return code;
	};

	const extractEmails = (personne, role) => {
		if (!personne) return [];
		const { personne_email1, personne_email2 } = personne;
		const emails = [];

		if (personne_email1) {
			emails.push({
				value: personne_email1,
				label: `${personne_email1} (email 1 ${role})`,
				emailIndex: 1
			});
		}

		if (personne_email2 && personne_email2 !== personne_email1) {
			emails.push({
				value: personne_email2,
				label: `${personne_email2} (email 2 ${role})`,
				emailIndex: 2
			});
		}

		return emails;
	}

	const mails = useMemo(() => {
		let allMails = [];

		if (action === 'owner' && owner?.proprietaire_personne) {
			allMails = extractEmails(owner.proprietaire_personne, 'propriétaire');
		}

		if (action === 'requete' && requete) {
			const tenantMails = extractEmails(requete?.requete_locataire?.locataire_personne, 'locataire');
			const ownerMails = extractEmails(location?.location_lot?.lot_proprietaire?.proprietaire_personne, 'propriétaire');
			allMails = [...tenantMails, ...ownerMails];
		}

		//console.log('passe useEffect MaillerContainer', action, allMails);
		// Supprimer les doublons basés sur la valeur de l'email
		return allMails.reduce((acc, current) => {
			const exists = acc.find(item => item.value === current.value);
			if (!exists) {
				acc.push(current);
			}
			return acc;
		}, []);

		// Pas de dependence pour location
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [action, requete, owner]);

	return (
		// TODO : Padding... En attentant la refonte ui (rustine)
		<div style={{ padding: action === 'requete' ? 20 : "inherit" }}>
			<Row gutter={16}>
				<Col span={24}>
					{/*<Button
						type="primary"
						onClick={() => setOpen(true)}
					>
						Open
					</Button>*/}
				</Col>
				<Col md={24} xl={14} xxl={17}>
					<MaillerForm
						bdd={bdd}
						owner={owner}
						document={newPiecesJointe}
						langue={getLangue}
						action={action}
						mails={mails}
					/>
				</Col>
				<Col md={24} xl={10} xxl={7}>
					<MaillerHistory action={action} mails={mails} bdd={bdd}/>
				</Col>
			</Row>
			{/* pour le futur dev des documents */}
			{/*<MaillerDocument open={open} onClose={handleClose}/>*/}
		</div>
	)
}